// What NX recorded, as the timeline's camera lanes draw it.

export type Periods = { start: number; end: number }[];

/** A stretch reaching this close to the time it was asked up to was still being recorded then. */
export const RUNNING_SLACK_MS = 10_000;

/**
 * Footage is asked for once a minute, so the stretch NX was still recording ends at the time of the last answer. On an
 * open event that stretch runs on to now: otherwise the lane shows "nothing recorded" from the last answer to the
 * playhead, which read as the video stopping at the alarm (staging, 2026-10-27). Stretches that had ended stay as they are.
 */
export function withRunning(p: Periods, asOf: number, now: number): Periods {
  const last = p.at(-1);
  if (!last || now <= asOf || last.end < asOf - RUNNING_SLACK_MS) return p;
  return [...p.slice(0, -1), { start: last.start, end: now }];
}

export const recordedAt = (p: Periods, t: number) => p.some((x) => t >= x.start && t < x.end);
